import React, { Component } from 'react'
import deleteGif from '../../../src/assets/assets_theme/img/trash-can.gif'
import blockUser from '../../../src/assets/assets_theme/img/block-user-man.png'
import img1 from "./../../assets/assets_theme/img/avatar/1.jpg"
import moment from 'moment';

export class CustomModalDailyTask extends Component {

// constructor(props) {
//   super(props);
//   this.state = {
//     data: this.props.data
//   }
// }


render() {
  let data = this.props.data;
  let title = this.props.title;
  let deleteQuiz = this.props.deleteQuiz;
  return (
    <div className="modal modal-center fade" id="modal-center-daily-task" tabindex="-1">
      <div className="modal-dialog" style={{maxWidth: '60%'}} role="document">
        <div className="modal-content">
            <div className="modal-header">
            <h5 className="modal-title">{title}: {moment().subtract(this.props.month == "this_month"? 0 : 1, "month").format("MMMM YYYY")}</h5>
            <button type="button" class="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div className="modal-body">
            <div class="media" style={{alignItems: 'center'}}>
                {/* <img class="avatar" src={user.profile_url ? user.profile_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." /> */}
                <img class="avatar" src={data.user.profile_url ? data.user.profile_url : img1} alt="..." />
                <div class="media-body">
                <h6> 
                  { data.user.first_name ? data.user.first_name : ''} { data.user.last_name ? data.user.last_name : ''} { data.user.nick_name ? data.user.nick_name : ''}
                </h6>
                </div>
              </div>
            

            <div className="table-container">
                      <table className="fixed-header-table" >
                        <thead>
                          <tr>
                            <th>#</th>
                            {/* <th>Thumbnail</th> */}
                            <th>Time</th>
                            <th>Description</th>
                            {/* <th>Code</th>
                            <th>Category</th> */}
                            {/* <th>Release Date</th> */}
                            {/* <th className="text-center w-150px">Actions</th> */}
                          </tr>
                        </thead>
                        <tbody>
                        {
                          this.props.data.task && this.props.data.task.map((quiz, index)=> {

                            return <tr >
                              <th scope="row">{index+1} </th>
                              {/* <td>
                                <div class="media">
                                  <img class="avatar" src={quiz.full_image_url ? quiz.full_image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                                  <div class="media-body">
                                  </div>
                                </div>
                              </td> */}
                              <td>{quiz.time}</td>
                              <td>{quiz.description}</td>
                              {/* <td className="w-100px">{quiz.code}</td> */}
                              
                              {/* <td>{moment(quiz.created_at).format("DD-MMM-YYYY")}</td> */}
                              
                            </tr>
                            
                          })
                        }
                        </tbody>
                      </table>
                     </div>
            

            </div>
            <div className="modal-footer">
            <button type="button" className="btn btn-bold btn-pure btn-secondary" data-dismiss="modal" onClick={() => data = null}>Close</button>
            {/* <button type="button" className="btn btn-bold btn-pure btn-danger" data-dismiss="modal" onClick={this.props.blockUser}>{this.props.data.block ? 'Unblock' : 'Block'}</button> */}

            {/* <button type="button" className="btn btn-bold btn-pure btn-info" data-dismiss="modal" onClick={this.props.approveUser}>{this.props.data.approveUser ? 'Not Approve' : 'Approve'}</button> */}

            {/* {data.approve == 0 && data.block == 0  && <button type="button" className="btn btn-bold btn-pure btn-info" data-dismiss="modal" onClick={this.props.approveUser}>Approve</button>} */}


            {/* <button type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={this.props.blockUser}>Block</button> */}
            </div>
          </div>
        </div>
    </div>
  )
}
}

export default CustomModalDailyTask